import {useCallback} from 'react';
import {TWhatsAppProps, TEmailProps, TSmsProps} from '../types';
import {TXHR} from '../../../assets/constants/constansts.type';
import {TemplateStructure} from '../../whatsAppTemplateEditor/types/templateStructure';

interface CreateSendingPropsParams {
    whatsappData: {image: {path: string, imageId: string}, message: string, whatsappTemplate?: TemplateStructure};
    emailData: {image: {path: string, imageId: string}, emailBody: string, emailSubject: string};
    smsData: {message: string};
    handleDataSave: (data: any, key: string, type: string) => void;
    handleSend: (type: string, trialRecipients?: string[]) => Promise<boolean>;
    sendingXHR: TXHR;
    whatsappTemplate: TemplateStructure;
    variablesType: string;
    emailButtons?: React.ReactNode;
}

export const createSendingProps = ({
    whatsappData,
    emailData,
    smsData,
    handleDataSave,
    handleSend,
    sendingXHR,
    whatsappTemplate,
    variablesType,
    emailButtons
}: CreateSendingPropsParams) => {
    const createProps = useCallback((type: 'whatsapp' | 'email' | 'sms') => {
        const baseProps = {
            send: () => handleSend(type),
            sendTrial: (trialPhones: string[]) => handleSend(type, trialPhones),
            sendingXHR
        };

        switch (type) {
            case 'whatsapp':
                return {
                    ...baseProps,
                    image: whatsappData.image,
                    whatsappTemplate: whatsappData.whatsappTemplate || whatsappTemplate,
                    saveImage: (image: string) => handleDataSave({path: image, imageId: ''}, 'image', type),
                    saveText: (structure: TemplateStructure) => handleDataSave(structure, 'whatsappTemplate', type)
                } as TWhatsAppProps;

            case 'email':
                return {
                    ...baseProps,
                    image: emailData.image,
                    emailBody: emailData.emailBody,
                    emailSubject: emailData.emailSubject,
                    setEmailBody: (text: string) => handleDataSave(text, 'emailBody', type),
                    setEmailSubject: (subject: string) => handleDataSave(subject, 'emailSubject', type),
                    saveImage: (image: string) => handleDataSave({path: image, imageId: ''}, 'image', type),
                    variablesType: variablesType,
                    buttons: emailButtons
                } as TEmailProps;

            case 'sms':
                return {
                    ...baseProps,
                    message: smsData.message,
                    saveMessage: (message: string) => handleDataSave(message, 'message', type),
                    variablesType: variablesType
                } as TSmsProps;

            default:
                return baseProps;
        }
    }, [whatsappData, emailData, smsData, handleDataSave, handleSend, sendingXHR]);

    return {
        whatsappProps: createProps('whatsapp') as TWhatsAppProps,
        emailProps: createProps('email') as TEmailProps,
        smsProps: createProps('sms') as TSmsProps
    };
};
